export enum NavigationPathsEnum {
    LOGIN = '/login',
    OTP_VERIFICATION = '/otp-verification',
    DASHBOARD = '/',
    PROFILE = '/profile',
    USERS = '/users',
    MEMBERS = '/members',
    ORDERS = '/orders',
    SETTINGS_VISIBILITY = '/settings/visibility',
    SETTINGS_PRICING = '/settings/pricing',
    SETTINGS_NOTIFICATIONS = '/settings/notifications',
    SETTINGS_LEGAL = '/settings/legal',
    PAYMENTS = '/payments',
}
